import React from "react";

export  function TextBoldXS({
  color = "gray-800",
  truncate,
  wrap = "wrap",
  whitespace = "normal",
  content,
  align
}) {
  return (
    <p
      className={` text-xs text-${align} font-semibold text-${color} text-${wrap} whitespace-${whitespace} ${
        truncate ? "truncate" : ""
      }`}
    >
      {content}
    </p>
  );
}

export  function TextBoldSM({
    color = "gray-800",
    truncate,
    wrap = "wrap",
    whitespace = "normal",
    content,
    align
  }) {
    return (
      <p
        className={` text-sm  text-${align} font-semibold text-${color} text-${wrap} whitespace-${whitespace} ${
          truncate ? "truncate" : ""
        }`}
      >
        {content}
      </p>
    );
  }

  export  function TextBoldBase({
    color = "gray-800",
    truncate,
    wrap = "wrap",
    whitespace = "normal",
    content,
    align="left"
  }) {
    return (
      <p
        className={` text-base text-${align} font-semibold text-${color} text-${wrap} whitespace-${whitespace} ${
          truncate ? "truncate" : ""
        }`}
      >
        {content}
      </p>
    );
  }

  export  function TextBoldXL({
    color = "gray-800",
    truncate,
    wrap = "wrap",
    whitespace = "normal",
    content,
    align="left"
  }) {
    return (
      <p
        className={` text-xl text-${align} font-semibold text-${color} text-${wrap} whitespace-${whitespace} ${
          truncate ? "truncate" : ""
        }`}
      >
        {content}
      </p>
    );
  }

  export  function TextBoldXXL({
    color = "gray-800",
    truncate,
    wrap = "wrap",
    whitespace = "normal",
    content,
    align="left"
  }) {
    return (
      <p
        className={` text-2xl text-${align} font-semibold text-${color} text-${wrap} whitespace-${whitespace} ${
          truncate ? "truncate" : ""
        }`}
      >
        {content}
      </p>
    );
  }
